import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles()((theme) => ({
  container: {
    ...dFlex('initial', 'initial'),
    backgroundColor: theme.secondary.s5,
    borderRadius: 8,
    flexDirection: 'column',
    gap: 16,
    padding: 16,
    width: '100%',
  },
}));

export default useStyles;
